<div class="header">
    {{ 'money.rentLabel' | translate }}
</div>
<div class="description">
    {{ 'money.rentDesc' | translate }}
</div>

@if(preloader.regularWithdrawals) {
    <div data-cy="rent-list-api-preloader" class="preloader-container">
        <libero-preload-spinner></libero-preload-spinner>
    </div>
} @else if(!allClientPortfolios.length) {
    <div data-cy="rent-list-no-available-investments" class="api-error-container">
        {{ 'money.noInvestments' | translate }}
    </div>
} @else if(!displayNewWithdrawalOverlay) {
    @if(apiError.regularWithdrawals) {
        <div class="api-error-container" data-cy="rent-list-api-error">
            {{ 'global.error.loadData' | translate }}
        </div>
    } @else if(!withdrawalsLength) {
        <div data-cy="rent-list-no-available-investments" class="api-error-container">
            {{ 'money.noWithdrawals' | translate }}
        </div>
        <div class="new-rent-btn-container mt-5">
            <libero-button
                (click)="toggleNewWithdrawalOverlay()"
                label="{{ 'money.newRentBtnLabel' | translate }}"
                btnClasses="btn--primary btn--big btn--small-dynamic-font"
                data-cy="rent-new-withrawal-btn"
            ></libero-button>
        </div>
    } @else {
        <div class="withdrawals-layout-bg" [ngClass]="{ 'withdrawals-layout-bg--visible': withdrawalsLength > 0 }">
            <div
                class="withdrawals-layout"
                data-cy="rent-list-loaded-content"
                @slideFromBottom
            >
                @if(withdrawalsLength > 0) {
                    <div class="withdrawals-header">
                        {{ 'money.withdrawalsHeader' | translate }}
                    </div>
                    <div class="phone-content mt-4">
                        @for(withdrawalDraft of withdrawalDrafts; track withdrawalDraft.regularWithdrawalDraftId) {
                            <libero-rent-withdrawal-draft-card
                                [withdrawalDraft]="withdrawalDraft"
                                [investmentType]="getInvestmentType(withdrawalDraft.portfolioId)"
                                [aml]="!!aml"
                            ></libero-rent-withdrawal-draft-card>
                        }
                        @for(withdrawal of regularWithdrawals; track withdrawal.regularWithdrawalId) {
                            <libero-rent-withdrawal-card [withdrawal]="withdrawal" [investmentType]="getInvestmentType(withdrawal.portfolioId)"></libero-rent-withdrawal-card>
                        }
                    </div>
                    <div class="desktop-content position-relative">
                        @if(withdrawalsLength < 4) {
                            <div class="withdrawals-container" data-cy="rent-list-simple-cards">
                                @for(withdrawalDraft of withdrawalDrafts; track withdrawalDraft.regularWithdrawalDraftId) {
                                    <libero-rent-withdrawal-draft-card
                                        [withdrawalDraft]="withdrawalDraft"
                                        [investmentType]="getInvestmentType(withdrawalDraft.portfolioId)"
                                        [aml]="!!aml"
                                    ></libero-rent-withdrawal-draft-card>
                                }
                                @for(withdrawal of regularWithdrawals; track withdrawal.regularWithdrawalId) {
                                    <libero-rent-withdrawal-card [withdrawal]="withdrawal" [investmentType]="getInvestmentType(withdrawal.portfolioId)"></libero-rent-withdrawal-card>
                                }
                            </div>
                        } @else {
                            <div class="desktop-owned-swiper-prev swiper-arrow swiper-arrow--left">
                                <svg-icon src="assets/icons/arrow.svg" [svgStyle]="{ 'width.px':18 }"></svg-icon>
                            </div>
                            <div class="withdrawals-carousel" data-cy="rent-list-swiper-cards">
                                <swiper
                                    [slidesPerView]="3"
                                    [pagination]="{
                                        clickable: true
                                    }"
                                    [navigation]="{
                                        enabled: true,
                                        nextEl:'.desktop-owned-swiper-next',
                                        prevEl:'.desktop-owned-swiper-prev',
                                        disabledClass: 'swiper-arrow--disabled'
                                    }"
                                    [slidesOffsetBefore]="18"
                                    [slidesOffsetAfter]="18"
                                    [spaceBetween]="15"
                                    [freeMode]="true"
                                >
                                    @for (withdrawalDraft of withdrawalDrafts; track withdrawalDraft.regularWithdrawalDraftId) {
                                        <ng-template swiperSlide>
                                            <libero-rent-withdrawal-draft-card
                                                [withdrawalDraft]="withdrawalDraft"
                                                [investmentType]="getInvestmentType(withdrawalDraft.portfolioId)"
                                                [aml]="!!aml"
                                            ></libero-rent-withdrawal-draft-card>
                                        </ng-template>
                                    }
                                    @for (withdrawal of regularWithdrawals; track withdrawal.regularWithdrawalId) {
                                        <ng-template swiperSlide>
                                            <libero-rent-withdrawal-card [withdrawal]="withdrawal" [investmentType]="getInvestmentType(withdrawal.portfolioId)"></libero-rent-withdrawal-card>
                                        </ng-template>
                                    }
                                </swiper>
                            </div>
                            <div class="desktop-owned-swiper-next swiper-arrow swiper-arrow--right">
                                <svg-icon src="assets/icons/arrow.svg" [svgStyle]="{ 'width.px':18, 'transform': 'rotate(180deg)' }"></svg-icon>
                            </div>
                        }
                    </div>
                }

                <div class="new-rent-btn-container">
                    <libero-button
                        (click)="toggleNewWithdrawalOverlay()"
                        label="{{ 'money.newRentBtnLabel' | translate }}"
                        btnClasses="btn--primary btn--big btn--small-dynamic-font"
                        data-cy="rent-new-withrawal-btn"
                    ></libero-button>
                </div>
            </div>
        </div>
    }
} @else {
    <div class="form-background" data-cy="rent-new-withdrawal-container">
        <div class="new-form-container" @slideFromBottom>
            @if(!withdrawalAvailablePortfolios || !withdrawalAvailablePortfolios.length) {
                <div class="api-error-container">
                    {{ 'money.noWithdrawableInvestments' | translate }}
                </div>
            } @else {
                <div class="label-wrapper label-wrapper--dropdown">
                    <div class="select-label">
                    {{ 'money.fromSelectLabel' | translate }}
                    </div>
                    <div class="dropdown-container">
                        <libero-money-dropdown-select
                            [availableWithdrawInvestments]="withdrawalAvailablePortfolios"
                            [formName]="withdrawForm.controls['investmentId']"
                            data-cy="rent-new-withdrawal-investments"
                        ></libero-money-dropdown-select>
                    </div>

                    <div class="arrow-down"></div>
                </div>

                <div class="label-wrapper label-wrapper--dropdown">
                    <div class="select-label">
                    {{ 'money.bankAccountsSelectLabel' | translate }}
                    </div>
                    @if(this.availableBankAccounts.length) {
                        <div class="dropdown-container">
                            <libero-money-dropdown-select
                                [availableBankAccounts]="parsedBankAccounts"
                                [formName]="withdrawForm.controls['clientBankAccountId']"
                                data-cy="rent-new-withdrawal-bank-accouns"
                            ></libero-money-dropdown-select>
                        </div>
                    }
                </div>

                <div class="label-wrapper">
                    <div class="select-label">
                    {{ 'money.amount' | translate }}
                    </div>
                    @if(valueWithdrawLimits) {
                        <libero-money-amount-input
                            [formName]="withdrawForm.controls['amount']"
                            currency="Kč"
                            [min]="valueWithdrawLimits.minAllowedWithdrawal"
                            [max]="valueWithdrawLimits.maxAllowedWithdrawal"
                            data-cy="rent-new-withdrawal-value"
                            [invalidText]="{
                                min: ( 'money.withdrawalForm.invalidAmouthMin' | translate) + ( valueWithdrawLimits.minAllowedWithdrawal | price:'CZK' ),
                                max: ( 'money.withdrawalForm.invalidAmouthMax' | translate),
                            }"
                        ></libero-money-amount-input>
                    }
                </div>

                <div class="label-wrapper">
                    <div class="select-label">
                        {{ 'money.frequency' | translate }}
                    </div>
                    <div class="dropdown-container radio-wrapper">
                        <libero-radio-input-group
                            [cyId]="'new-withdrawal-frequency-radios'"
                            [availableValues]="availablePeriods"
                            [formName]="withdrawForm.controls['withdrawRegularity']"
                        ></libero-radio-input-group>
                    </div>
                </div>
                <div class="label-wrapper label-wrapper--full-width">
                    <div class="select-label">
                        {{ 'money.validTo' | translate }}
                    </div>

                    <div class="valid-to-container">
                        <label class="radio-container">
                            <div class="form-label">
                                {{ 'money.unlimited' | translate }}
                            </div>
                            <input
                                data-cy="rent-new-withdrawal-unlimited"
                                id="unlimited-validity-check"
                                type="radio"
                                value="unlimited"
                                [name]="unlimitedValidity"
                                (change)="updateValidToValue('unlimited')"
                                [checked]="withdrawForm.value.validTo === unlimitedValidity"
                            />
                            <span class="checkmark"></span>
                        </label>

                        <div class="calendar-wrapper" [ngClass]="{'calendar-wrapper--inactive': withdrawForm.value.validTo === unlimitedValidity}">
                            <div class="form-label">
                                {{ 'money.toDate' | translate }}
                            </div>
                            <div class="calendar-container">
                                <input
                                    data-cy="to-date-calendar-trigger"
                                    class="calendar-input"
                                    [owlDateTimeTrigger]="dt"
                                    [owlDateTime]="dt"
                                    [min]="tomorrow"
                                    (dateTimeChange)="updateValidToValue($event.value)"
                                    readonly
                                >
                                <owl-date-time #dt [pickerType]="'calendar'"></owl-date-time>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="buttons-wrapper label-wrapper--full-width" @slideFromBottom>
                    <libero-button
                        data-cy="rent-new-withdrawal-back-btn"
                        label="{{ 'global.buttons.back' | translate }}"
                        btnClasses="btn--icon-text icon--secondary"
                        (click)="hideNewWithdrawalOverlay()"
                    ></libero-button>
                    <libero-button
                        data-cy="rent-new-withdrawal-confirm-btn"
                        label="{{ 'money.confirmNewWithdrawal' | translate }}"
                        btnClasses="btn--primary btn--heading"
                        (click)="openWithdrawalConfirmModal()"
                        [preloader]="preloader.newWithdraw"
                    ></libero-button>
                </div>
            }
        </div>
    </div>

}